/**
 * @description: Request result set
 * 200：请求成功
 * 301：微信未授权
 * 302：未绑定用户信息
 * 303：未设置隐私密码
 * 304：未验证隐私密码
 * 305：安全会话已过期
 * 400：请求错误，请修正请求
 * 401：没有被授权或者授权已经失效
 * 403：请求被理解，但是拒绝执行
 * 404：资源未找到
 * 405：请求方法不允许被执行
 * 408：请求超时
 * 429：请求过多
 * 500：服务器内部错误
 * 502：响应无效
 * 504：上游服务器超时
 */
export enum ResultEnum {
  /**
   * 请求成功
   */
  SUCCESS = '200',
  /**
   * 验证过，跳到首页
   */
  ERROR_201 = '201',
  /**
   * 微信未授权
   */
  ERROR_301 = '301',
  /**
   * 未绑定用户信息
   */
  ERROR_302 = '302',
  /**
   * 未设置隐私密码
   */
  ERROR_303 = '303',
  /**
   * 未验证隐私密码
   */
  ERROR_304 = '304',
  /**
   * 安全会话已过期
   */
  ERROR_305 = '305',
  /**
   * 请求错误，请修正请求
   */
  ERROR_400 = '400',
  /**
   * 没有被授权或者授权已经失效
   */
  ERROR_401 = '401',
  /**
   * 请求被理解，但是拒绝执行
   */
  ERROR_403 = '403',
  /**
   * 资源未找到
   */
  ERROR_404 = '404',
  /**
   * 请求方法不允许被执行
   */
  ERROR_405 = '405',
  /**
   * 请求超时
   */
  ERROR_408 = '408',
  /**
   * 请求过多
   */
  ERROR_429 = '429',
  /**
   * 服务器内部错误
   */
  ERROR_500 = '500',
  /**
   * 响应无效
   */
  ERROR_502 = '502',
  /**
   * 上游服务器超时
   */
  ERROR_504 = '504',
  /**
   * 未认证
   */
  ERROR_701 = '701',
  /**
   * 未认证
   */
  ERROR_703 = '703',
  /**
   * 兜底错误
   */
  ERROR = '500',
  /**
   * 超时
   */
  TIMEOUT = '401',
  /**
   * 成功标识
   */
  TYPE = 'success',
}

/**
 * @description: request method
 */
export enum RequestEnum {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
}

/**
 * @description:  contentType
 */
export enum ContentTypeEnum {
  // json
  JSON = 'application/json;charset=UTF-8',
  // form-data qs
  FORM_URLENCODED = 'application/x-www-form-urlencoded;charset=UTF-8',
  // form-data  upload
  FORM_DATA = 'multipart/form-data;charset=UTF-8',
}
